/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

export type IntegrationStatus = (typeof IntegrationStatus)[keyof typeof IntegrationStatus];

export const IntegrationStatus = {
  NONE: 'none',
  NOTCONFIGURED: 'notConfigured',
  CONNECTED: 'connected',
  NOTENOUGHPERMISSIONS: 'notEnoughPermissions',
  SECRETEXPIRED: 'secretExpired',
  DISABLEDBYSUPERADMIN: 'disabledBySuperAdmin',
} as const;
